import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'sc-wrapper-border',
  templateUrl: './wrapper-border.component.html',
  styleUrls: ['./wrapper-border.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrapperBorderComponent extends FieldWrapper implements OnInit {
  ngOnInit(): void {}
}
